<span class="date-chip" [class.active]="dateLabel">
  {{ dateLabel ? (dateLabel | translate) : (date | customDate ) }}
</span>
